import numberCustomerImage from '../images/registrations/info_version/info-1.png';
import hourSavedImage from '../images/registrations/info_version/info-2.png';
import finalistImage from '../images/registrations/info_version/info-3.png';
import effortlessImage from '../images/registrations/info_version/info-4.png';

const SlideDesktopData = [
  {
    backgroundCss: 'infoBg',
    question: 'Did you know?',
    imageCss: 'infoImages',
    imageItem: {
      url: numberCustomerImage,
      alt: '300+ customers',
    },
    colorWord: 'infoColor',
    titleCss: 'infoTitle',
    title: '300+ customers',
    description: {
      firstDes: 'Ever since 2015, Rakuna has had the honor',
      secondDes: 'to serve over 300 global companies',
    },
  },
  {
    backgroundCss: 'infoBg',
    question: 'Did you know?',
    imageCss: 'infoImages',
    imageItem: {
      url: hourSavedImage,
      alt: '1400+ hours saved',
    },
    colorWord: 'infoColor',
    titleCss: 'infoTitle',
    title: '1400+ hours saved',
    description: {
      firstDes: 'With Rakuna help, companies have been able',
      secondDes: 'to save 1400+ recruiting hours annually',
    },
  },
  {
    backgroundCss: 'infoBg',
    question: 'Did you know?',
    imageCss: 'infoImages',
    imageItem: {
      url: finalistImage,
      alt: 'Finalist',
    },
    colorWord: 'infoColor',
    titleCss: 'infoTitle',
    title: 'Finalist',
    description: {
      firstDes: 'Rakuna was the finalist of MN Cup 2016 - the largest',
      secondDes: 'statewide business competition in the U.S. with 1400+ entries',
    },
  },
  {
    backgroundCss: 'infoBg',
    question: 'Did you know?',
    imageCss: 'infoImages',
    imageItem: {
      url: effortlessImage,
      alt: 'Effortless',
    },
    colorWord: 'infoColor',
    titleCss: 'infoTitle',
    title: 'Effortless',
    description: {
      firstDes: '"Rakuna" means "effortless" in Japanese',
      secondDes: undefined,
    },
  },
];

export default SlideDesktopData;
